function rgbToHexFromStep(step, maxStep) {
  const green = Math.round(((step - 1) / maxStep) * 255);
  const r = 255;
  const g = green;
  const b = 0;
  return `#${[r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')}`;
}

function formatFechaSimulation(fechaISO) {
    const fecha = new Date(fechaISO);

    const opcionesFecha = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'Europe/Madrid'
    };

    const opcionesHora = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Europe/Madrid'
    };

    const fechaFormateada = new Intl.DateTimeFormat('es-ES', opcionesFecha).format(fecha);
    const horaFormateada = new Intl.DateTimeFormat('es-ES', opcionesHora).format(fecha);

    return `${fechaFormateada} - ${horaFormateada}`;
}


export { rgbToHexFromStep, formatFechaSimulation };